import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-switch-status',
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './switch-status.component.html',
    styleUrl: './switch-status.component.css'
})
export class SwitchStatusComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  @Input() activeModalContext: any;
  @Input() status: any;

  ngOnInit() {
    const control = this.formGroup.get(this.fields.fieldName);

    if (control) {
      if (
        control.value === null ||
        control.value === undefined ||
        control.value === ''
      ) {
        control.patchValue(true);
      } else if (control.value === 'Active' || control.value === true) {
        control.patchValue(true);
      } else if (control.value === 'Inactive' || control.value === false) {
        control.patchValue(false);
      }
    }
  }

  get isActive(): boolean {
    const value = this.formGroup.get(this.fields.fieldName)?.value;
    return value === 'Active' || value === true;
  }

  formatDisplayName(value: string): string {
    if (!value) return '';

    const uppercaseWords = ['api', 'url', 'id', 'ip', 'dns', 'sso', 'saml', 'oauth', 'tls', 'ssl'];
    const originalWords = value.split(' ');

    return value
      .toLowerCase()
      .split(' ')
      .map((word, index) => {
        const originalWord = originalWords[index];
        if (originalWord && originalWord === originalWord.toUpperCase() && isNaN(Number(originalWord))) {
          return originalWord;
        }
        const cleanWord = word.replace(/[^a-z0-9]/g, '');
        if (uppercaseWords.includes(cleanWord)) {
          return word.toUpperCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }
  onSwitchChange(event: any) {
    const isChecked = event.target.checked;
    const fieldName = this.fields.fieldName;
    const control = this.formGroup.get(fieldName);
    if (control) {
      control.markAsDirty();
      control.setValue(isChecked);
    }
  }
}
